class ReviewsTabController {
  constructor({
    containerSelector = '#product_just_stars_container',
    tabLinkSelectors   = [
      '.tab-title[href="#tab-reviews"]',
      '.toggleLink[href="#tab-reviews-mobile"]'
    ],
    activeClass       = 'is-open',
    scrollOffset      = 50,
    fallbackDelay     = 500
  } = {}) {
    this.containerSelector = containerSelector;
    this.tabLinkSelectors  = tabLinkSelectors;
    this.activeClass       = activeClass;
    this.scrollOffset      = scrollOffset;
    this.fallbackDelay     = fallbackDelay;
    this._observerConfig   = { attributes: true, attributeFilter: ['class'] };

    if (document.readyState !== 'loading') {
      this._init();
    } else {
      document.addEventListener('DOMContentLoaded', () => this._init());
    }
  }

  _init() {
    const containers = document.querySelectorAll(this.containerSelector);
    if (!containers.length) {
      return;
    }
    containers.forEach(c => c.addEventListener('click', e => this._onClick(e)));
  }

  _onClick(evt) {
    evt.preventDefault();

    // pick the first tab‐link that exists and is visible
    const tabLink = this.tabLinkSelectors
      .map(sel => document.querySelector(sel))
      .find(el => el && this._isVisible(el));

    if (!tabLink) {
      return;
    }

    const href   = tabLink.getAttribute('href');
    const target = href && document.querySelector(href);
    if (!target) {
      return;
    }

    if (tabLink.classList.contains(this.activeClass)) {
      this._scrollTo(target);
    } else {
      this._openAndScroll(tabLink, target);
    }
  }

  _isVisible(el) {
    return !!(el.offsetWidth || el.offsetHeight || el.getClientRects().length);
  }

  _scrollTo(el) {
    const topY    = el.getBoundingClientRect().top + window.scrollY;
    const offsetY = Math.max(0, topY - this.scrollOffset);
    window.scrollTo({ top: offsetY, behavior: 'smooth' });
  }

  _openAndScroll(tabLink, targetEl) {
    if (typeof MutationObserver === 'undefined') {
      tabLink.click();
      setTimeout(() => this._scrollTo(targetEl), this.fallbackDelay);
      return;
    }

    const obs = new MutationObserver((mutations, observer) => {
      if (tabLink.classList.contains(this.activeClass)) {
        observer.disconnect();
        this._scrollTo(targetEl);
      }
    });
    obs.observe(tabLink, this._observerConfig);

    tabLink.click();

    // fallback
    setTimeout(() => {
      obs.disconnect();
      this._scrollTo(targetEl);
    }, this.fallbackDelay);
  }
}

// auto‐instantiate with default desktop + mobile selectors:
new ReviewsTabController({
  scrollOffset: 80,
  fallbackDelay: 600
});
